import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Profile, ProfileManagement } from '@cyborg-monorepo/hunter/common';
import { environment } from '../../../../../environments/environment';
import { ConfirmedValidator } from '../../../../helpers/password.validator';
import { UserService } from '../../../shared/services/user.service';

@Component({ standalone: false, 
  templateUrl: './my.component.html',
  styleUrls: ['./my.component.scss'],
})
export class MyAccountComponent implements OnInit {
  public isEditing = false;
  public userForm: FormGroup;
  public passwordForm: FormGroup;
  public createdAt: Date;
  public role: string;
  public specialCharacters: string = ProfileManagement.SPECIAL_CHARACTERS;
  public passRegex: string = ProfileManagement.passwordRegEx;
  public error: string = '';
  public avatar = '/assets/img/temp-avatar.png';

  constructor(
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private userService: UserService,
  ) {
    this.passwordForm = this.formBuilder.group(
      {
        oldPassword: ['', Validators.required],
        newPassword: ['', Validators.required],
        confirmNewPassword: ['', Validators.required],
      },
      { validator: ConfirmedValidator('newPassword', 'confirmNewPassword') },
    );
  }

  public ngOnInit(): void {
    this.userForm = new FormGroup({
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required]),
      phoneNumber: new FormControl('', [Validators.required]),
    });

    this.userService.getProfile().subscribe((profile: Profile) => {
      this.userForm.patchValue({
        firstName: profile.firstName,
        lastName: profile.lastName,
        email: profile.email,
        phoneNumber: profile.phoneNumber,
      });

      this.createdAt = profile.createdAt;
      this.role = profile.role;
    });
  }

  public onEdit(): void {
    this.isEditing = !this.isEditing;
  }
  public onSave(): void {
    const profile = {
      firstName: this.userForm.value.firstName,
      lastName: this.userForm.value.lastName,
      email: this.userForm.value.email,
      phoneNumber: this.userForm.value.phoneNumber,
    };
    this.http.put(`${environment.api}/me/profile`, profile).subscribe(() => {
      this.isEditing = !this.isEditing;
    });
  }

  public onChangePassword(): void {
    if (this.passwordForm.valid) {
      const password = {
        oldPassword: this.passwordForm.value.oldPassword,
        password: this.passwordForm.value.confirmNewPassword,
      };

      this.userService.updatePassword(password).subscribe(
        () => {
          this.passwordForm.reset({
            oldPassword: '',
            newPassword: '',
            confirmNewPassword: '',
          });
          document
            .querySelector('.change-password .updated')
            .classList.add('is-updated');
          setTimeout(() => {
            document
              .querySelector('.change-password .updated')
              .classList.remove('is-updated');
          }, 5000);
        },
        (error) => {
          this.error =
            error.message || 'There was an issue resetting your password.';
        },
      );
    }
  }
}
